/**
 * @generated SignedSource<<926559935d96714cdc2f3908057aabd7>>
 * @relayHash 04a2990e8f89356b716b4fa0b8c7b93b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 730beb4039e9e81173ca804b12c625befbc6b5e4b36082ce298c6893a1fff65d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentLandingQuery } from './srcVirtualAgentLandingQuery.graphql';

import replaceVsaWithRovoAgentsFG_provider from '@atlassian/jira-relay-provider/src/jsm-replace-vsa-with-rovo-agents.relayprovider';
import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';
import showNextStepsEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-next-steps.relayprovider';
import vaStatusHeaderEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-status-header.relayprovider';

const node: PreloadableConcreteRequest<srcVirtualAgentLandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "730beb4039e9e81173ca804b12c625befbc6b5e4b36082ce298c6893a1fff65d",
    "metadata": {},
    "name": "srcVirtualAgentLandingQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": vaStatusHeaderEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": showNextStepsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmreplacevsawithrovoagentsrelayprovider": replaceVsaWithRovoAgentsFG_provider
    }
  }
};

export default node;
